import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../hooks';
import { Link } from 'react-router-dom';
import { Section as StreamerSection } from './Streamer/Section';
import { Section as EngineSection } from './Engine/Section';

import {
  TopBarContainer,
  SideNavContainer,
  BreadcrumbContainer,
} from '../../../components/Dashboard';

import { dashboardBreadcrumb } from '../../../data/routes';
import {
  Layout,
  PageNavContainer,
  MainContainer,
  PageNavLeftContainer,
} from './../../Styles';

export const widgetWidth = '375px';
export const widgetHeight = '215px';

const AdminLayout = observer(() => {
  const {
    DashboardStore: { connected },
    AuthStore: { memberName },
    UIStore: { setHeaderText },
  } = useStores();

  const heading = 'Custom Engine Tools';
  const breadcrumbItems = [dashboardBreadcrumb, { label: heading }];

  React.useEffect(() => {
    setHeaderText(null);
  }, []);

  return (
    <Layout>
      <TopBarContainer
        connected={connected}
        title={heading}
        memberName={memberName}
        showLogout
      />
      <SideNavContainer />
      <PageNavContainer>
        <PageNavLeftContainer>
          <Breadcrumbs data={breadcrumbItems} />
        </PageNavLeftContainer>
        {/* <PageNavRightContainer>
          <div>Right Container</div>
        </PageNavRightContainer> */}
      </PageNavContainer>
      <MainContainer>
        <EngineSection />
        <StreamerSection />
      </MainContainer>
    </Layout>
  );
});

export default AdminLayout;

export const Breadcrumbs = ({ data }) => {
  return (
    <BreadcrumbContainer>
      {data.map(({ to, label }) =>
        to ? (
          <Link key={to} to={to}>
            {label}
          </Link>
        ) : (
          label
        ),
      )}
    </BreadcrumbContainer>
  );
};
